import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  materialTypes: 'MaterialTypes',
  priceSheets: 'PriceSheets',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.materialTypes],
  endpoints: {
    getMaterialTypes: {
      providesTags: result =>
        result && result.Items
          ? // successful query
            [
              ...result.Items.map(materialType => ({
                type: TAG_TYPES.materialTypes,
                id: materialType.id,
              })),
              { type: TAG_TYPES.materialTypes, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'materialTypes', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.materialTypes, id: 'LIST' }],
    },
    createMaterialType: {
      invalidatesTags: [{ type: TAG_TYPES.materialTypes, id: 'LIST' }, { type: TAG_TYPES.priceSheets }],
    },
    getMaterialType: {
      providesTags: (result, error, { materialTypeId }) => [{ type: TAG_TYPES.materialTypes, id: materialTypeId }],
    },
    patchMaterialType: {
      invalidatesTags: (result, error, { materialTypeId }) => [
        { type: TAG_TYPES.materialTypes, id: 'LIST' },
        { type: TAG_TYPES.materialTypes, id: materialTypeId },
        { type: TAG_TYPES.priceSheets },
      ],
    },
    archiveMaterialType: {
      invalidatesTags: (result, error, { materialTypeId }) => [
        { type: TAG_TYPES.materialTypes, id: 'LIST' },
        { type: TAG_TYPES.materialTypes, id: materialTypeId },
      ],
    },
  },
})

export const useGetMaterialTypeLazyQuery = api.endpoints.getMaterialType.useLazyQuery

export const {
  useGetMaterialTypesQuery,
  useCreateMaterialTypeMutation,
  useGetMaterialTypeQuery,
  usePatchMaterialTypeMutation,
  useArchiveMaterialTypeMutation,
} = api
